'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var booleanSome = {};

exports.__exports = booleanSome;
